import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getJwtToken } from "../../AdminReducer/action";

let END_POINT

if (window.location.protocol === 'http:') {
    END_POINT = `http://localhost:5001`
}
else {
    END_POINT = `https://${window.location.host}/api`
}


export const getAllDropDowns = createAsyncThunk(
  "dropdown/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${END_POINT}/dropdown/`, {
        headers: {
          Authorization: getJwtToken()
        }
      });
      // console.log(res.data);
      return res.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return []; // ✅ No items, return empty array instead of rejecting
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


export const createDropDown = createAsyncThunk("dropdown/create",
  async (userData,  { rejectWithValue  })  => {
    try  {
      const res  = await axios.post(`${END_POINT}/dropdown/addVariables`, userData, {
      headers: {
        Authorization: getJwtToken()
      }
    });
      return res.data;
     } catch (error)  {
      console.log(error)
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  })


export const editDropDown = createAsyncThunk(
  "dropdown/edit",
  async (userData, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${END_POINT}/dropdown/editVariables`, userData, {
        headers: {
          Authorization: getJwtToken()
        }
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const deleteDropDown = createAsyncThunk(
  "dropdown/delete",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${END_POINT}/dropdown/deleteVariables`, { data }, {
        headers: {
          Authorization: getJwtToken()
        }
      });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);